<template>
  <v-card outlined class="modern-card overflow-hidden">
    <!-- Header -->
    <v-sheet color="primary" dark class="px-6 py-4">
      <div class="d-flex align-center">
        <v-avatar color="white" size="48" class="mr-4">
          <v-icon color="primary">fas fa-building</v-icon>
        </v-avatar>
        <div>
          <h2 class="text-h6 font-weight-bold mb-0 lh-1">{{selected.name}}</h2>
          <div class="caption opacity-80 mt-1">{{selected.fantasy || 'Sin nombre de fantasía'}}</div>
        </div>
        <v-spacer></v-spacer>
        <v-btn icon small @click="$emit('close')" class="white--text opacity-70">
          <v-icon small>fas fa-times</v-icon>
        </v-btn>
      </div>
    </v-sheet>

    <v-card-text class="pa-6">
      <div class="d-flex justify-space-between align-center mb-6">
        <div>
          <div class="text-overline grey--text lh-1">RUC / RUT</div>
          <div class="body-1 font-weight-bold">{{selected.rut}}</div>
        </div>
        <div class="text-right">
          <v-chip color="success" x-small label outlined class="font-weight-bold" v-if="selected.status">ACTIVO</v-chip>
          <v-chip color="error" x-small label outlined class="font-weight-bold" v-else>INACTIVO</v-chip>
        </div>
      </div>

      <v-divider class="mb-4"></v-divider>

      <!-- Contact Info -->
      <div class="mb-6">
        <div class="text-overline grey--text mb-2 d-flex align-center">
          <v-icon x-small class="mr-2">fas fa-users</v-icon> Contactos
        </div>
        <v-list dense class="pa-0 bg-transparent">
          <v-list-item v-for="contact in selected.contacts" :key="contact.id" class="px-0 min-h-auto mb-2">
            <v-list-item-avatar size="24" color="grey lighten-4" class="my-0">
              <v-icon x-small color="grey darken-1">fas fa-user-circle</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <v-list-item-title class="caption font-weight-bold">
                {{contact.first_name}} {{contact.last_name}}
              </v-list-item-title>
              <v-list-item-subtitle class="x-small grey--text">
                {{contact.email}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div v-if="!selected.contacts || selected.contacts.length == 0" class="caption grey--text italic px-2">
            No hay contactos registrados
          </div>
        </v-list>
      </div>

      <!-- Address Info -->
      <div class="mb-6">
        <div class="text-overline grey--text mb-2 d-flex align-center">
          <v-icon x-small class="mr-2">fas fa-map-marker-alt</v-icon> Direcciones
        </div>
        <v-list dense class="pa-0 bg-transparent">
          <v-list-item v-for="address in selected.addresses" :key="address.id" class="px-0 min-h-auto mb-2">
            <v-list-item-avatar size="24" color="grey lighten-4" class="my-0">
              <v-icon x-small color="grey darken-1">fas fa-location-arrow</v-icon>
            </v-list-item-avatar>
            <v-list-item-content class="py-0">
              <v-list-item-title class="caption font-weight-medium">
                {{address.street}} {{address.number}}
              </v-list-item-title>
              <v-list-item-subtitle class="x-small grey--text">
                {{address.comune}}, {{address.region}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
          <div v-if="!selected.addresses || selected.addresses.length == 0" class="caption grey--text italic px-2">
            No hay direcciones registradas
          </div>
        </v-list>
      </div>

      <v-divider class="mb-4"></v-divider>

      <!-- Seller Info -->
      <div v-if="selected.seller" class="d-flex align-center justify-space-between bg-light rounded pa-3">
        <div class="d-flex align-center">
          <v-icon small color="primary" class="mr-3">fas fa-user-tie</v-icon>
          <div>
            <div class="text-overline grey--text lh-1" style="font-size: 0.65rem !important;">Ejecutivo Comercial</div>
            <div class="caption font-weight-bold">{{selected.seller.first_name}} {{selected.seller.last_name}}</div>
          </div>
        </div>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "CustomerCard",
  props: {
    selected: {
      type: Object,
      required: true
    }
  }
}
</script>

<style scoped>
.modern-card {
  border: 1px solid rgba(0,0,0,0.08) !important;
}
.lh-1 { line-height: 1.2; }
.opacity-80 { opacity: 0.8; }
.opacity-70 { opacity: 0.7; }
.bg-light { background-color: #f8f9fa; }
.x-small { font-size: 0.75rem !important; }
.min-h-auto { min-height: auto !important; }
</style>